<template>
  <div class="event-handling-container">
    <!-- 标题区域 - 单独一行 -->
    <div class="event-title">
      {{ title }}
    </div>

    <!-- 内容区域 - options 和 event-list 并排 -->
    <div class="content-wrapper">
      <div style="display: flex;justify-content: center;margin-top: 15px;">
        <div style="display:flex;flex-direction: column;">
            <div style="position: relative;">
              <img :src="$staticUrl('/statics/2025/10/31/notice_top_left_20251031175700A264.png')" alt="" style="width: 240px;height: 80px;">
              <div style="position: absolute;top:22px;left:25px;display:flex; align-items: baseline;color:#FFFFFF;">
                <div style="font-size: 14px;margin-right: 5px;">法律文件</div>
                <div style="font-size: 20px !important;font-weight: bold;">{{ noticeCount }}</div>
              </div>
            </div>
            <div style="position: relative;">
              <img :src="$staticUrl('/statics/2025/10/31/notice_bottom_left_20251031180227A266.png')" alt="" style="width: 240px;height: 80px;">
              <div style="position: absolute;top:35px;left:28px;display:flex; align-items: baseline;color:#FFFFFF;">
                <div style="font-size: 14px;margin-right: 5px;">法规文件</div>
                <div style="font-size: 20px !important;font-weight: bold;">{{ noticeCount1 }}</div>
              </div>
            </div>
        </div>
        <div style="position: relative;margin: 0 10px;">
          <img :src="$staticUrl('/statics/2025/10/31/notice_statistics_20251031180015A265.png')" alt="" style="width: 200px;height: 180px;vertical-align: bottom;">
          <div style="position: absolute;top:35px;left: 0;right: 0; display:flex;flex-direction: column;align-items: center;">
            <div style="font-size: 28px !important;font-weight: bold;color:#E3F5FF;">{{ totalCount }}</div>
            <div style="font-size: 18px;color:#fff;">累计发送</div>
          </div>
        </div>
        <div style="display:flex;flex-direction: column;">
            <div style="position: relative;">
              <img :src="$staticUrl('/statics/2025/11/01/notice_top_right_20251101095139A268.png')" alt="" style="width: 240px;height: 80px;">
              <div style="position: absolute;top:22px;right:28px;display:flex; align-items: baseline;color:#FFFFFF;">
                <div style="font-size: 14px;margin-right: 5px;">条例文件</div>
                <div style="font-size: 20px !important;font-weight: bold;">{{ noticeCount2 }}</div>
              </div>
            </div>
            <div style="position: relative;">
              <img :src="$staticUrl('/statics/2025/11/01/notice_bottom_right_20251101095259A269.png')" alt="" style="width: 240px;height: 80px;">
              <div style="position: absolute;top:35px;right:28px;display:flex; align-items: baseline;color:#FFFFFF;">
                <div style="font-size: 14px;margin-right: 5px;">紧急通知</div>
                <div style="font-size: 20px !important;font-weight: bold;">{{ noticeCount3 }}</div>
              </div>
            </div>
        </div>
      </div>
      <div style="background: #000000;margin: 10px 15px;flex:1;display: flex;flex-direction: column;">
        <div style="padding: 10px;color:#fff;border-bottom: 1px solid #10363C;">新建通知</div>
        <div class="box">
          <div class="box_one">
            <div class="color_fff_14" style="margin-right: 10px;">通知类型</div>
            <el-select v-model="value" placeholder="请选择" style="height: 36px; flex:1;background: #013230;border-radius: 5px;">
              <el-option style="background: #000;"
                v-for="item in options"
                :key="item.id"
                :label="item.noticeTypeName"
                :value="item.id">
              </el-option>
            </el-select>
            <div :class="emergencyStatus == 0 ? 'active' : 'active_no'" @click="emergencyStatus = 0">普通通知</div>
            <div :class="emergencyStatus == 1 ? 'active' : 'active_no'" @click="emergencyStatus = 1">紧急通知</div>
          </div>
          <div class="box_one" style="margin-top: 10px;">
            <div class="color_fff_14" style="margin-right: 10px;">通知物业</div>
            <el-select v-model="value1" placeholder="请选择" multiple style="height: 36px; flex:1;background: #013230;border-radius: 5px;">
              <el-option style="background: #000;"
                v-for="item in estateList"
                :key="item.estateId"
                :label="item.estateName"
                :value="item.estateId">
              </el-option>
            </el-select>
          </div>
          <div class="box_one" style="margin-top: 10px;">
            <div class="color_fff_14" style="margin-right: 10px;">通知标题</div>
            <el-input placeholder="请输入内容" v-model="noticeTitle" style="flex:1;background: #013230;border-radius: 5px;">
            </el-input>
          </div>
          <div class="box_one" style="margin-top: 10px;align-items: flex-start;flex:1;">
            <div class="color_fff_14" style="margin-right: 10px;">通知内容</div>
            <div style="display: flex;flex-direction: column;flex:1;background: #013230;border-radius: 5px;height: 100%;">
              <div id="editor" style="background: #fff; color: #000; min-height: 200px;"></div>
              <div class="upload-container">
                <el-upload
                  ref="upload"
                  class="upload-hidden"
                  action="https://estatea.zyzhkjbj.com/prod-api/file/upload"
                  :on-success="handleUploadSuccess"
                  :on-error="handleUploadError"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :limit="5"
                  :on-exceed="handleExceed"
                  :auto-upload="true"
                  :show-file-list="false"
                  drag>
                  <div style="display: none;"></div>
                </el-upload>
                <div class="file-list">
                  <div v-for="(file, index) in fileList" :key="index" class="file-item" v-if="fileList.length > 0">
                    <img src="@/assets/file.png" alt="" style="width: 45px;height: 45px;vertical-align: bottom;">
                    <span class="file-name">{{ file.name }}</span>
                    <!-- <span class="file-size">{{ formatFileSize(file.size) }}</span> -->
                    <i class="el-icon-close" @click="handleRemove(file, fileList)"></i>
                  </div>
                </div>
                <div class="upload-area" @click="$refs.upload.$el.querySelector('.el-upload__input').click()">
                  <i class="el-icon-paperclip" style="font-size: 16px;color: #0EE0D4;"></i>
                  <div class="upload-text">添加文件</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button @click="addNotice(0)">保存草稿</el-button>
          <el-button @click="addNotice(1)">立即发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueProgressDialog from './vueprogressdialog.vue';
import {Message} from "element-ui";
import {typeDictList,addNotice,statisticsNotice} from "@/api/notice";
import {getAllEstate} from "@/api/estate";
import axios from 'axios'  // 添加这行
// 引入 wangEditor
import E from 'wangeditor'

export default {
  name: 'vueapply',
  components: {
    VueProgressDialog
  },
  data() {
    return {
        noticeCount: 0,
        noticeCount1: 0,
        noticeCount2: 0,
        noticeCount3: 0,
        totalCount: 0,
        // 其他数据
        editor: null,
        editorContent: '',
        parentActiveIndex: 0,
        activeIndex: 0,
        // 通知类型
        emergencyStatus: 0,
        value: '',
        value1: '',
        noticeTitle: '',
        input1: '',
        estateList:[],
        options: [],
        title:'发起通知',
        title1: '',
        fileList: [],  // 上传文件列表
        file:[], //参数文件
        uploadUrl: '/api/upload',  // 上传接口地址
    }
  },
  created() {
    this.statisticsNotice()
    this.getAllEstate()
    this.typeDictList()
  },
  mounted() {
    this.initEditor()
  },
  beforeDestroy() {
    // 组件销毁时，及时销毁编辑器
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  methods: {
    statisticsNotice() {
      statisticsNotice().then(res => {
        this.noticeCount = res.data.list[0].noticeCount
        this.noticeCount1 = res.data.list[1].noticeCount
        this.noticeCount2 = res.data.list[2].noticeCount
        this.noticeCount3 = res.data.statusNum
        this.totalCount = res.data.totalNum
      })
    },
    // 查询通知类型
    typeDictList() {
      typeDictList().then(res => {
        this.options = res.data;
      })
    },
    // 查询物业
    getAllEstate() {
      getAllEstate().then(res => {
        this.estateList = res.data;
      })
    },
    addNotice(type){
      console.log(this.getEditorContent());
      console.log(this.value);
      console.log(this.value1.toString(','));
      addNotice({
        noticeTypeId: this.value,
        estateIds: this.value1.toString(','),
        noticeTitle: this.noticeTitle,
        noticeContent: this.getEditorContent(),
        emergencyStatus: this.emergencyStatus,
        noticeStatus: type,
        url: this.file.toString(',')
      }).then(res => {
        this.$message.success('添加成功');
        this.$router.push('/notice');
      })
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
    // 删除文件
    handleRemove(file, fileList) {
      const index = this.fileList.indexOf(file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
    },
    
    // 测试上传功能成功时的回调
    handleUploadSuccess(response, file, fileList) {
      
      console.log(response);
      if(response.code == 200){
        this.$message.success('文件上传成功');
        this.fileList = fileList;
        this.file.push(response.data.url)
      }
      // 这里可以处理上传成功后的逻辑，比如保存文件信息到表单数据中
    },
    
    // 文件上传失败时的回调
    handleUploadError(err, file, fileList) {
      this.$message.error('文件上传失败');
      console.error('上传错误:', err);
    },
    
    // 上传文件之前的钩子
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10; // 限制文件大小10MB
      const isDocument = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ].includes(file.type);
      
      if (!isDocument) {
        this.$message.error('只能上传pdf/doc/docx/xls/xlsx格式的文件!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
        return false;
      }
      return true;
    },
    
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    
    // 测试上传功能
    initEditor() {
      // 创建编辑器
      this.editor = new E('#editor')
      
      // 配置菜单栏
      this.editor.config.menus = [
        'head',                  // 标题
        'bold',                 // 粗体
        'fontSize',             // 字号
        'fontName',             // 字体
        'italic',               // 斜体
        'underline',            // 下划线
        'strikeThrough',        // 删除线
        'foreColor',            // 文字颜色
        'backColor',            // 背景颜色
        'link',                 // 插入链接
        'list',                 // 列表
        'justify',              // 对齐方式
        'quote',                // 引用
        'emoticon',             // 表情
        'image',                // 插入图片
        'table',                // 表格
        'code',                 // 插入代码
        'undo',                 // 撤销
        'redo'                  // 重复
      ]
      
      // 在 initEditor 方法中，更新图片上传配置
      this.editor.config.uploadImgServer = 'https://estatea.zyzhkjbj.com/prod-api/file/upload'
      this.editor.config.uploadFileName = 'file' // 设置上传文件的参数名
      this.editor.config.uploadImgParams = {
        // 可以添加额外的参数，例如：
        // token: 'your-token-here'
      }

      // 修改上传钩子函数
      this.editor.config.uploadImgHooks = {
        // 图片上传并返回结果，图片插入成功之后触发
        success: (xhr, editor, result) => {
          console.log('上传成功', result)
          // 这里可以根据后端返回的数据结构进行调整
          if (result.code === 200) {
            // 假设返回的数据中有 url 字段
            const url = result.data.url
            // 插入图片到编辑器
            editor.cmd.do('insertHtml', `<img src="${url}" style="max-width:100%;"/>`)
          }
        },
        // 自定义上传（如果需要完全自定义上传逻辑）
        customInsert: (insertImgFn, result) => {
          // result 即服务端返回的接口
          console.log('customInsert', result)
          // 这里根据后端返回的数据结构调整
          if (result.code === 200) {
            const url = result.data.url
            insertImgFn(url)
          }
        },
        // 上传错误
        error: (xhr, editor) => {
          console.error('上传出错', xhr)
          this.$message.error('图片上传失败')
        },
        // 上传超时
        timeout: (xhr) => {
          console.error('上传超时')
          this.$message.error('上传超时，请重试')
        }
      }
      
      // 创建编辑器
      this.editor.create()
      
      // 设置初始内容
      this.editor.txt.html(this.editorContent)
    },
    
    // 获取编辑器内容
    getEditorContent() {
      const content = this.editor.txt.html()
      console.log('编辑器内容：', content)
      return content
    },
    
    // 设置编辑器内容
    setEditorContent(content) {
      this.editor.txt.html(content)
    }
  }
}
</script>

<style scoped>
/* 上传区域样式 */
.upload-container {
  margin: 15px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.upload-area {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.3s;
  margin-left: 15px;
}

.upload-area:hover {
  border-color: #409EFF;
}

.upload-text {
  font-size: 14px;
  color: #0EE0D4;
  margin-left: 2px;
}

.upload-hint {
  font-size: 12px;
  color: #999;
}

.upload-hidden {
  display: none;
}

.file-list {
  margin-top: 5px;
  margin-left: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  flex: 1;
}

.file-item {
  display: flex;
  background: linear-gradient( 360deg, #06585A 0%, rgba(0,59,61,0.3) 100%);
  padding: 5px;
  height: 45px !important;
  margin-right: 10px;
  border-radius: 10px;
}

.file-item i {
  margin-right: 8px;
  color: #409EFF;
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 5px;
}

.file-size {
  color: #999;
  margin-right: 10px;
}

.file-item .el-icon-close {
  cursor: pointer;
  color: #999;
  font-size: 14px;
}

.file-item .el-icon-close:hover {
  color: #F56C6C;
}
/* 编辑器容器样式 */
#editor {
  line-height: 1.5;
  color: #000;
  min-height: 160px;  /* 设置最小高度 */
  height: 200px;      /* 设置固定高度 */
  display: flex;
  flex-direction: column;
}

/* 工具栏样式 */
::v-deep .w-e-toolbar {
  background-color: #f1f1f1 !important;
  border: 1px solid #ccc !important;
  border-radius: 4px 4px 0 0 !important;
  flex-shrink: 0;  /* 防止工具栏被压缩 */
}

/* 编辑区域样式 */
::v-deep .w-e-text-container {
  border: 1px solid #ccc !important;
  border-top: none !important;
  border-radius: 0 0 4px 4px !important;
  flex: 1;  /* 让编辑区域填充剩余空间 */
  min-height: 160px !important;
  height: auto !important;  /* 允许高度自动调整 */
  background: #fff;
}

/* 编辑区域内容容器 */
::v-deep .w-e-text {
  min-height: 160px !important;
}

/* 调整下拉菜单样式 */
::v-deep .w-e-drop-list {
  z-index: 10000 !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  #editor {
    height: 250px;
  }
  
  ::v-deep .w-e-text-container,
  ::v-deep .w-e-text {
    min-height: 150px !important;
  }
}

.event-handling-container {
  display: flex;
  flex-direction: column; /* 垂直排列：标题 + 内容 */
  width: 1530px;
  height: 880px;
  background-color: rgba(51,142,134,0.16);
  border-radius: 4px;
  overflow: hidden;
}

/* 标题样式 - 渐变背景 */
.event-title {
  width: 320px;
  padding: 10px 20px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  background-image: linear-gradient(135deg, #016565, #0a2442);
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
  flex-shrink: 0; /* 防止被压缩 */
}

.content-wrapper {
  display: flex;
  flex-direction: column; /* 垂直排列：标题 + 内容 */
  flex: 1;
  width: 1530px;
  overflow: hidden;
}

.box {
  display: flex;
  flex-direction: column;
  padding: 10px;
  flex: 1;
}

.box_one {
  display: flex;
  align-items: center;
}

.color_fff_14 {
  color: #fff;
  font-size: 14px;
}

::v-deep .el-input__inner::placeholder {
  color: #fff; /* 输入文字颜色 */
}

::v-deep .el-textarea__inner::placeholder {
  color: #fff; /* 输入文字颜色 */
}

::v-deep .el-input__inner {
  height: 36px !important;
}

/deep/ .el-button {
  background: linear-gradient( 360deg, #00B6B3 0%, rgba(0,121,117,0.57) 33%, rgba(0,121,117,0) 72%, #008785 100%);
  color: #B1F7FA;
  border: none;
  border-radius: 30px;
  width: 80px;
}

.dialog-footer {
  display: flex;
  padding: 0 20px 10px 20px;
  justify-content: end;
}

.active {
  color: #0EE0D4;
  background: #165D56;
  border-radius: 5px;
  border: 1px solid #0EE0D4;
  height: 36px;
  font-size: 13px;
  line-height: 36px;
  padding: 0 15px;
  margin-left: 10px;
}

.active_no {
  color: #fff;
  background: rgba(18,59,55,0.5);
  border-radius: 5px;
  border: 1px solid rgba(18,59,55,0.5);
  height: 36px;
  font-size: 13px;
  line-height: 36px;
  padding: 0 15px;
  margin-left: 10px;
}
</style>
